// extracted by mini-css-extract-plugin
export default {"btn":"ForgotPassword_btn__wYFrU","container":"ForgotPassword_container__cKTC1","title":"ForgotPassword_title__hkaQP","error":"ForgotPassword_error__XhxCj"};